export default (value: string) => {
  return Number(value.replace(/\D+/g, ''));
};
